module.exports = function () {
  const accordionElements = document.querySelectorAll('.cover-accordion')
  let accordionIsOpen = false

  function addAccordionEventListeners () {
    for (let i = 0; i < accordionElements.length; i++) {
      const accordion = accordionElements[i]
      const accordionTitle = accordion.querySelector('.cover-accordion__title')
      accordionTitle.addEventListener('click', toggleAccordion)
    }
  }

  function toggleAccordion () {
    const accordion = this.parentElement
    const accordionContentWrap = accordion.querySelector('.cover-accordion__content-wrap')
    const accordionContent = accordion.querySelector('.cover-accordion__content')
    const accordionContentHeight = accordionContent.offsetHeight

    accordionContentWrap.offsetHeight === 0
      ? openAccordion(accordion, accordionContentWrap, accordionContentHeight)
      : closeAccordion(accordion, accordionContentWrap)
  }

  function openAccordion (accordion, accordionWrap, height) {
    if (accordionIsOpen) {
      closeAllAccordions()
    }

    accordionWrap.style.maxHeight = `${height}px`
    accordion.classList.add('cover-accordion--open')
    accordionIsOpen = true
  }

  function closeAccordion (accordion, accordionWrap) {
    accordionWrap.style.maxHeight = 0
    accordion.classList.remove('cover-accordion--open')
    accordionIsOpen = false
  }

  function closeAllAccordions () {
    for (let i = 0; i < accordionElements.length; i++) {
      const accordion = accordionElements[i]
      const accordionContentWrap = accordion.querySelector('.cover-accordion__content-wrap')
      closeAccordion(accordion, accordionContentWrap)
    }
  }

  if (accordionElements.length) {
    addAccordionEventListeners()
  }
}
